import { cn } from '@/utils/cn';

interface ExpressLogoProps {
	className?: string;
	fill?: string;
}

export const ExpressLogo = ({
	className,
	fill = '#2D2D2D',
}: ExpressLogoProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 16.58 16.61"
			fill={fill}
		>
			<path d="m11.69,2.26c-.58-1.37-1.92-2.26-3.41-2.26s-2.84.89-3.42,2.27L.18,13.4c-.64,1.52.47,3.2,2.13,3.2h5.21c1.28,0,2.31-1.04,2.31-2.32s-1.04-2.32-2.32-2.32c-.05,0-.89,0-.89,0-.38,0-.63-.38-.49-.73l1.66-3.96c.18-.43.77-.43.95,0l3.39,7.92c.47,1.06,1.35,1.4,2.13,1.4,1.65,0,2.77-1.69,2.13-3.21,0,0-4.71-11.14-4.71-11.14Z" />
		</svg>
	);
};
